import get from 'lodash/get'
import type { Table } from '@wmt/content-blocks'
import type { FilteredSchema, PlayerRoster } from '~/types'
import { toFloatByPath } from '~/statistics/utils/toFloatByPath'
import { defaultBodyCells, defaultColumns } from '~/statistics/playerRosters/aliases'
import { getSortAsNumber } from '~/shared/lib/sorts'
import { StatisticRootKey } from '~/enums/statistic-root-key'
import type { CellsReturnDataType, TableDataType } from '~/statistics/playerRosters/index'

export const columns: Table.Cell<PlayerRoster.Model>[] = [
  { content: 'Eff', sort: true },
  { content: 'C-A-I', sort: true },
  { content: 'Pct', sort: true },
  { content: 'Yds', sort: true },
  { content: 'TD', sort: true },
  { content: 'Lng', sort: true },
  { content: 'Avg/Gm', sort: true },
  { content: 'FUM-LST', sort: true },
]

export const cells = (type: StatisticRootKey = StatisticRootKey.Statistics): CellsReturnDataType => ([
  { content: `$get(${type}.passing.rating, 0)` }, // Eff
  {
    content: (data: TableDataType) => {
      const completions = get(data, `${type}.passing.completions`, 0)
      const attempts = get(data, `${type}.passing.attempts`, 0)
      const interceptions = get(data, `${type}.passing.interceptions`, 0)

      return `${completions} - ${attempts} - ${interceptions}`
    }, // C-A-I
  },
  { content: (data: TableDataType) => toFloatByPath(data, `${type}.passing.cmpPct`), onSort: getSortAsNumber }, // Pct
  { content: `$get(${type}.passing.grossYards, 0)` }, // Yds
  { content: `$get(${type}.passing.touchdowns, 0)` }, // TD
  { content: `$get(${type}.passing.longest, 0)` }, // Lng
  {
    content: (data: TableDataType) => toFloatByPath(data, `${type}.passing.avgYardsPerGame`),
    onSort: getSortAsNumber,
  }, // Avg/Gm
  {
    content: (data: TableDataType) => {
      const fumbles = get(data, `${type}.fumbles.fumbles`, 0)
      const lost = get(data, `${type}.fumbles.lostFumbles`, 0)

      return `${fumbles} - ${lost}`
    }, // FUM-LST
  },
])

export const playerRosterPassingStatsSchema: FilteredSchema<PlayerRoster.Model> = {
  filter: player => Boolean(player.statistics?.passing),
  schema: {
    head: {
      rows: [
        {
          cells: [
            ...defaultColumns,
            ...columns,
          ],
        },
      ],
    },
    body: {
      rows: {
        cells: [
          ...defaultBodyCells,
          ...cells() as Table.BodyCell<PlayerRoster.Model>[],
        ],
      },
    },
  },
}
